module.exports = __webpack_public_path__ + "img/gfx-step-5_x3.44aa5789.webp";